

// export const LOGOUT_TIME = 2*7*24*60*60*1000;

export const LOGOUT_TIME = 24*60*60*1000;

// export const LOGOUT_TIME = 0;


// WEBPACK FOOTER //
// ./src/constants/auth.jsx